import * as React from "react";

const Home = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer1"
      fill="none"
      stroke="#000"
      strokeDasharray="none"
      strokeOpacity="1"
      display="inline"
    >
      <path
        id="rect1"
        strokeWidth="0.443"
        d="M.66 2.236 2.783.425a.62.62 0 0 1 .805 0l2.122 1.81a1.15 1.15 65.234 0 1 .403.874v2.454a.53.53 135 0 1-.53.53H.788a.53.53 45 0 1-.53-.53V3.11a1.15 1.15 114.766 0 1 .403-.873Z"
        transform="matrix(.9037 0 0 .9037 .297 .315)"
      ></path>
      <path
        id="rect2"
        strokeWidth="0.4"
        d="M2.85 3.87h.914a.337.337 45 0 1 .337.336v1.615H2.514V4.206a.337.337 135 0 1 .336-.337Z"
        opacity="1"
        transform="translate(-.132)"
      ></path>
    </g>
  </svg>
);

export default Home;
